import { FETCH_PERMISSIONS } from "../../constants/action.constants";

const initialState = {
  list: [],
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PERMISSIONS:
      return { list: action.payload };
    default:
      return state;
  }
};

export default permissionsReducer;
